export { default } from './StoriesTable';
